import React from 'react';
import { Button } from '../ui/Button';
import { Check, ArrowRight, Gift, Truck, CreditCard } from 'lucide-react';
export function OfferSection() {
  return <section className="py-20 bg-white" id="oferta" data-id="element-134">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-136">
          <div className="grid md:grid-cols-2" data-id="element-137">
            <div className="p-8 md:p-12 bg-gray-900 text-white flex flex-col justify-between relative overflow-hidden" data-id="element-138">
              <div className="relative z-10" data-id="element-139">
                <h3 className="text-2xl font-bold mb-2 text-blue-300" data-id="element-140">
                  Oferta Premium
                </h3>
                <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6" data-id="element-141">
                  Kit Pies Sin Presión
                </h2>
                <div className="mb-6 rounded-xl overflow-hidden border border-white/10 bg-white/5" data-id="element-142">
                  <img src="https://cdn.magicpatterns.com/uploads/rMYFmEwVcLvLtkZ2rf38xd/1715617013-Bunion_Fix_Product_Photo_3_(1).webp" alt="Kit Pies Sin Presión — corrector de juanetes premium" className="w-full h-44 object-contain" data-id="element-143" />
                </div>
                <div className="space-y-4 mb-8" data-id="element-144">
                  <div className="flex items-center" data-id="element-145">
                    <div className="bg-blue-500/20 p-2 rounded-lg mr-4" data-id="element-146">
                      <Gift className="h-6 w-6 text-blue-300" data-id="element-147" />
                    </div>
                    <div data-id="element-148">
                      <p className="font-semibold" data-id="element-149">Kit Físico Premium</p>
                      <p className="text-sm text-gray-400" data-id="element-150">
                        Correctores ajustables de alta resistencia
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center" data-id="element-151">
                    <div className="bg-teal-500/20 p-2 rounded-lg mr-4" data-id="element-152">
                      <Gift className="h-6 w-6 text-teal-300" data-id="element-153" />
                    </div>
                    <div data-id="element-154">
                      <p className="font-semibold" data-id="element-155">Ebook Protocolo</p>
                      <p className="text-sm text-gray-400" data-id="element-156">
                        Guía paso a paso de desinflamación
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center" data-id="element-157">
                    <div className="bg-purple-500/20 p-2 rounded-lg mr-4" data-id="element-158">
                      <Truck className="h-6 w-6 text-purple-300" data-id="element-159" />
                    </div>
                    <div data-id="element-160">
                      <p className="font-semibold" data-id="element-161">Envío Bonificado</p>
                      <p className="text-sm text-gray-400" data-id="element-162">
                        A toda la Argentina
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Decorative circles */}
              <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 w-64 h-64 bg-blue-600 rounded-full blur-3xl opacity-20" data-id="element-163"></div>
              <div className="absolute bottom-0 left-0 translate-y-1/2 -translate-x-1/2 w-64 h-64 bg-teal-600 rounded-full blur-3xl opacity-20" data-id="element-164"></div>
            </div>

            <div className="p-8 md:p-12 bg-white flex flex-col justify-center" data-id="element-165">
              <div className="text-center mb-8" data-id="element-166">
                <p className="text-gray-500 line-through text-lg mb-2" data-id="element-167">
                  Precio Regular: AR$ 89.990
                </p>
                <div className="flex items-center justify-center gap-2 mb-4" data-id="element-168">
                  <span className="text-5xl font-bold text-gray-900" data-id="element-169">
                    AR$ 64.990
                  </span>
                </div>
                <div className="inline-flex items-center bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium mb-2" data-id="element-170">
                  <CreditCard className="w-4 h-4 mr-1" data-id="element-171" />3 cuotas sin interés de
                  AR$ 21.663
                </div>
                <p className="text-xs text-gray-500" data-id="element-172">
                  con Mercado Pago · Envío gratis a todo el país
                </p>
              </div>

              <a href="https://argrutinas.com/cart/42977556922577:1" target="_blank" rel="noopener noreferrer" className="w-full" onClick={() => {
              if (typeof window.fbq === 'function') {
                window.fbq('track', 'AddToCart', {
                  content_name: 'Kit Pies Sin Presión',
                  content_ids: ['42977556922577'],
                  content_type: 'product',
                  value: 64990,
                  currency: 'ARS'
                });
              }
            }} data-id="element-173">
                <Button variant="cta" size="xl" className="w-full mb-4 group shadow-xl shadow-orange-500/20" data-id="element-174">
                  Comprar Ahora
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-175" />
                </Button>
              </a>

              <p className="text-center text-sm text-gray-500 mb-8" data-id="element-176">
                Pago en 1 o hasta 3 cuotas sin interés. Acceso inmediato al
                material digital.
              </p>

              <div className="space-y-3 border-t pt-6" data-id="element-177">
                <div className="flex items-center text-sm text-gray-600" data-id="element-178">
                  <Check className="h-4 w-4 text-green-500 mr-2" data-id="element-179" />
                  Resultados visibles en 30 días
                </div>
                <div className="flex items-center text-sm text-gray-600" data-id="element-180">
                  <Check className="h-4 w-4 text-green-500 mr-2" data-id="element-181" />
                  Soporte prioritario por WhatsApp
                </div>
                <div className="flex items-center text-sm text-gray-600" data-id="element-182">
                  <Check className="h-4 w-4 text-green-500 mr-2" data-id="element-183" />
                  Envío gratis — sin costo adicional
                </div>
                <div className="flex items-center text-sm text-gray-600" data-id="element-184">
                  <Check className="h-4 w-4 text-green-500 mr-2" data-id="element-185" />
                  Garantía de devolución de 30 días
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}